import NextButton from "../NextButton";
import { TextField, Typography } from "@mui/material";
import { UserInfo } from "../MobileWizard";
import "../../MobileSign/MobileSign.scss";
import "../MobileWizard.scss";
import validator from "validator";

interface EmailStepProps {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfo>>;
  userInfo: UserInfo;
  isDesktop?: boolean;
}

const EmailStep: React.FC<EmailStepProps> = ({
  setActiveStep,
  setUserInfo,
  userInfo,
  isDesktop,
}) => {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    setUserInfo((prev) => ({ ...prev, email: event.target.value }));
  }

  const isValid = validator.isEmail(userInfo.email);
  const showError = userInfo.email.length > 0 && !isValid;
  return (
    <div className="stepBody">
      <div className="wizardStep__fieldWrap">
        <Typography className="wizardStep__heading" variant="h4">
          {" "}
          What's your Email?
        </Typography>
        <Typography className="wizardStep__label"> Email address </Typography>
        <TextField
          style={{ width: isDesktop ? "50%" : "100%" }}
          variant="outlined"
          InputProps={{ className: "customedInput" }}
          value={userInfo.email}
          onChange={handleChange}
          name="email"
          placeholder="Email address"
          type="email"
          autoComplete="email"
          inputProps={{ inputMode: "email" }}
          error={showError}
          // Reserve the helper line so the layout doesn't jump when it appears.
          helperText={showError ? "Enter a valid email address" : " "}
        />
      </div>
      <NextButton
        label="Next"
        setActiveStep={setActiveStep}
        disabled={!isValid}
      ></NextButton>
    </div>
  );
};

export default EmailStep;
